<template><svg class="ico ico__play" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" role="img" aria-label="Play"><path fill="#fff" d="M36 25 13 38V12l23 13Z"/></svg>
</template>